/* eslint-disable import/prefer-default-export */
import { combineReducers } from 'redux';

import user from '@/application/redux/reducers/user';
import noti from '@/application/redux/reducers/noti';
import packageReducer from '@/application/redux/slices/packageSlice';
import gameReducer from '@/application/redux/slices/gameListSlice';
import supplierReducer from '@/application/redux/slices/supplierListSlice';
import packageStatsReducer from '@/application/redux/slices/packageStatsSlice';
import reportReducer from '@/application/redux/slices/reportSlice';
import serialCodeReducer from '@/application/redux/slices/serialCodeSlice';
import serialCodeStatsReducer from '@/application/redux/slices/serialCodeStatsSlice';
import distributorReducer from '@/application/redux/slices/distributorSlice';
import agentTierReducer from '@/application/redux/slices/agentTierSlice';
import bankReducer from '@/application/redux/slices/bankSlice';
import businessReducer from '@/application/redux/slices/businessSlice';
import customerDiscountTierReducer from '@/application/redux/slices/customerDiscountTierSlice';
import streamerReducer from '@/application/redux/slices/streamerSlice';

export const rootReducer = combineReducers({
  user,
  noti,
  package: packageReducer,
  game: gameReducer,
  supplier: supplierReducer,
  agentTier: agentTierReducer,
  packageStats: packageStatsReducer,
  report: reportReducer,
  serialCode: serialCodeReducer,
  serialCodeStats: serialCodeStatsReducer,
  distributor: distributorReducer,
  bank: bankReducer,
  business: businessReducer,
  customerDiscountTier: customerDiscountTierReducer,
  streamer: streamerReducer,
});
